import React, { Component } from "react";
import { Fetch, downloadPDF } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import { Table, DatePicker, message, ConfigProvider, Modal } from "antd";
import Loader from "../../utils/loader";
import less from "./invoice.module.scss";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import moment from "moment";
import jwt from "../../utils/jwt";
import GenericPopup from "../../components/GenericPopup";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../config";
dayjs.extend(isoWeek);

const { RangePicker } = DatePicker;

const columns = [
  {
    title: "Route",
    dataIndex: "route",
  },
  {
    title: "Start Time & Date",
    dataIndex: "date",
  },
  {
    title: "Trip ID",
    dataIndex: "tripId",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Asset Type",
    dataIndex: "assetType",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

class buses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      tableLoader: false,
      showSideMenu: false,
      isMobile: false,
      selectedRowKeys: [],
      createInvoiceModal: false,
      showBillGeneration: false,
      selectedInvoices: [],
      invoiceTableData: [],
      isRcm: false,
      invoiceDate: null,
      userDetails: null,
      showPopup: false,
      popupType: "error",
      popupHeading: "",
      popupMessage: "",
      showSecondButton: false,
      secondButtonText: "",
      pdfUrl: null,
      invoiceFileName: "",
      isGeneratingInvoice: false,
      isSubmittingInvoice: false,
      invoiceNumber: "",
      invoiceNumberError: "",
      currentDateRange: null,
      showMobileFilter: false,
      filterFromDate: dayjs().startOf("week").add(1, "day"),
      filterToDate: dayjs().endOf("day"),
    };
  }

  fetchProfileDetails = async (userMobileNo) => {
    try {
      const url = `/cabOperator/details?mobileNo=${userMobileNo}`;
      const options = {
        method: "get",
      };

      const response = await Fetch(url, options);
      if (response) {
        const userDetails = response[0];
        const bankDetails = userDetails.bankDetails || {};
        const isRcm = userDetails.isRcm;
        const today = moment().format("DD/MM/YYYY");
        const invoiceDate = isRcm !== true ? today : null;

        this.setState({
          isRcm: isRcm === true,
          invoiceDate: invoiceDate,
          userDetails: userDetails,
        });
      } else {
        console.warn(`No data found for mobile number: ${userMobileNo}`);
      }
    } catch (error) {
      console.error("Error fetching profile details:", error);
    }
  };

  async componentDidMount() {
    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    const userMobileNo = decodedToken.mobileNo;
    this.fetchProfileDetails(userMobileNo);
    try {
      const stateObj = { loading: false };
      const invoice = await this.fetchInvoice();
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      stateObj.invoiceTableData = invoice.formatTableData;
      stateObj.userMobileNo = userMobileNo;
      this.setState(stateObj);
    } catch (err) {
      console.error(err);
    }
  }

  componentWillUnmount() {
    if (this.state.pdfUrl) {
      window.URL.revokeObjectURL(this.state.pdfUrl);
    }
  }

  fetchInvoice = async () => {
    const fromDate = new Date();
    const toDate = new Date();

    const currentDay = fromDate.getDay();

    const distanceToMonday = currentDay === 0 ? -6 : 1 - currentDay;
    fromDate.setDate(fromDate.getDate() + distanceToMonday);
    fromDate.setHours(0, 0, 0, 0);

    toDate.setHours(23, 59, 59, 999);

    const fromDateMs = fromDate.getTime();
    const toDateMs = toDate.getTime();

    const path = `/cabOperator/tripsForInvoice?fromDate=${fromDateMs}&toDate=${toDateMs}`;
    const options = {
      method: "get",
    };
    const trips = await Fetch(path, options);

    if (Array.isArray(trips) && trips.length > 0) {
      let formatTableData = this.formatData(trips);

      return { trips, formatTableData };
    } else {
      message.error("No Trip Found for Invoice Creation");
      return { trips: [], formatTableData: [] };
    }
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  resetPopupValues = () => {
    this.setState({
      invoiceNumber: "",
      invoiceNumberError: "",
    });
  };

  generateInvoiceNumber = () => {
    const { userDetails } = this.state;
    if (!userDetails || !userDetails.vendorCode) return;
    const vendorCode = userDetails.vendorCode;
    const now = new Date(Date.now());

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = String(now.getFullYear()).slice(-2);
    const invoiceDate = `${day}${month}${year}`;

    // Format time as HHMM (24-hour format)
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const invoiceTime = `${hours}${minutes}`;

    return `${vendorCode}${invoiceDate}${invoiceTime}`;
  };

  calculateTotalAmount = () => {
    const { selectedInvoices } = this.state;
    if (!selectedInvoices || selectedInvoices.length === 0) {
      return 0;
    }
    return selectedInvoices.reduce((total, invoice) => {
      const amount = parseFloat(invoice.amount) || 0;
      return total + amount;
    }, 0);
  };

  validateInvoiceForm = () => {
    const { invoiceNumber, selectedInvoices, isRcm } = this.state;

    if (!isRcm) {
      if (!invoiceNumber || invoiceNumber.trim() === "") {
        this.setState({
          invoiceNumberError: "Invoice number is required",
        });
        return false;
      }
    }

    this.setState({ invoiceNumberError: "" });

    if (!selectedInvoices || selectedInvoices.length === 0) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "No Trips Selected",
        popupMessage: "Please select at least one trip to create an invoice.",
        showSecondButton: false,
        secondButtonText: "",
      });
      return false;
    }

    return true;
  };

  validateUserDetails = () => {
    const { userDetails, isRcm } = this.state;

    if (!userDetails) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "User Details Missing",
        popupMessage: "User details not found",
      });
      return false;
    }

    if (!userDetails.regionalManagerId) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "Regional ID Missing",
        popupMessage: "Please Contact Admin to fix the same.",
      });
      return false;
    }

    // if (!userDetails.registeredStateId) {
    //   this.setState({
    //     showPopup: true,
    //     popupType: "error",
    //     popupHeading: "Registered State ID Missing",
    //     popupMessage: "Please Contact Admin to fix the same."
    //   });
    //   return false;
    // }

    if (
      !userDetails.kyc ||
      !userDetails.kyc.status ||
      userDetails.kyc.status !== "COMPLETED"
    ) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "KYC Verification Incomplete",
        popupMessage:
          "Please complete your KYC verification to proceed with invoice creation.",
        showSecondButton: true,
        secondButtonText: "Complete KYC",
      });
      return false;
    }

    if (!userDetails.hsnCode) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "HSN Code Missing",
        popupMessage: "Please Contact Admin to fix the same.",
      });
      return false;
    }

    if (!isRcm && !userDetails.gstRate) {
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "GST Rate Missing",
        popupMessage: "Please Contact Admin to fix the same.",
      });
      return false;
    }

    return true;
  };

  handleCreateInvoiceClick = () => {
    this.resetPopupValues();
    const { selectedInvoices } = this.state;

    const ontripInvoices = selectedInvoices.filter(
      (inv) => inv.status === "ONTRIP"
    );
    if (ontripInvoices.length > 0) {
      const tripIds = ontripInvoices.map((inv) => inv.tripId).join(", ");
      const isPlural = ontripInvoices.length > 1;
      this.setState({
        showPopup: true,
        popupType: "error",
        popupHeading: "Trip Not Completed",
        popupMessage: `${tripIds} ${isPlural ? "are" : "is"} ONTRIP, please mark ${isPlural ? "them" : "it"} completed first`,
        showSecondButton: false,
        secondButtonText: "",
      });
      return;
    }

    if (this.state.isRcm) {
      const generatedInvoiceNumber = this.generateInvoiceNumber();
      if (!generatedInvoiceNumber) {
        this.setState({
          showPopup: true,
          popupType: "error",
          popupHeading: "Vendor Code Missing",
          popupMessage: "Please Contact Admin to fix the same.",
        });
        return;
      }
      this.setState({
        createInvoiceModal: true,
        invoiceNumber: generatedInvoiceNumber,
        invoiceDate: moment().format("DD/MM/YYYY"),
      });
    } else {
      this.setState({ createInvoiceModal: true });
    }
  };

  handleContinueClick = async () => {
    if (!this.validateInvoiceForm()) {
      return;
    }

    if (!this.validateUserDetails()) {
      return;
    }

    this.setState({ isGeneratingInvoice: true });

    try {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Invoice Created", {
        view_from: "Invoice page",
        mobile_number: this.state.userMobileNo,
        type: "CABOWNER",
      });
      const { invoiceNumber, invoiceDate, selectedInvoices } = this.state;
      const { userDetails } = this.state;

      const checkPath = `/cabOperator/checkForInvoiceNumber?invoiceNumber=${encodeURIComponent(
        invoiceNumber
      )}`;
      const checkOptions = {
        method: "get",
      };

      const checkResponse = await Fetch(checkPath, checkOptions);

      if (checkResponse == "Invoice number exists") {
        this.setState({
          isGeneratingInvoice: false,
          showPopup: true,
          popupType: "error",
          popupHeading: "Duplicate Invoice Number",
          popupMessage:
            checkResponse.data ||
            "This invoice number already exists. Please use a different invoice number.",
          showSecondButton: false,
          secondButtonText: "",
        });
        return;
      }

      const invoiceDateTimestamp = moment(invoiceDate, "DD/MM/YYYY").valueOf();

      const requestBody = {
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDateTimestamp,
        cabOperatorId: userDetails._id,
        cabBookingGroupIds: selectedInvoices.map((invoice) => invoice.key),
      };

      const path = `/cabOperator/generateTemporaryInvoice`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: requestBody,
      };

      const pdfData = await downloadPDF(path, options, true);

      if (
        pdfData &&
        typeof pdfData === "object" &&
        pdfData.statusCode === "error"
      ) {
        this.setState({
          isGeneratingInvoice: false,
          showPopup: true,
          popupType: "error",
          popupHeading: "Invoice Generation Failed",
          popupMessage:
            pdfData.message || "Failed to generate invoice. Please try again.",
          showSecondButton: false,
          secondButtonText: "",
        });
        return;
      }

      if (pdfData && pdfData instanceof ArrayBuffer && pdfData.byteLength > 0) {
        try {
          const blob = new Blob([pdfData], { type: "application/pdf" });

          if (blob.size === 0) {
            throw new Error("Empty PDF blob generated");
          }

          const pdfUrl = window.URL.createObjectURL(blob);
          const fileName = `invoice_${invoiceNumber}_${moment().format(
            "YYYY-MM-DD"
          )}.pdf`;

          this.pdfBlob = blob;

          this.setState({
            createInvoiceModal: false,
            showBillGeneration: true,
            pdfUrl: pdfUrl,
            invoiceFileName: fileName,
            isGeneratingInvoice: false,
          });
        } catch (blobError) {
          this.setState({
            isGeneratingInvoice: false,
            showPopup: true,
            popupType: "error",
            popupHeading: "Invoice Generation Failed",
            popupMessage:
              "Failed to create PDF from response data. Please try again.",
            showSecondButton: false,
            secondButtonText: "",
          });
        }
      } else {
        this.setState({
          isGeneratingInvoice: false,
          showPopup: true,
          popupType: "error",
          popupHeading: "Invoice Generation Failed",
          popupMessage:
            "No PDF data received or invalid data format. Please try again.",
          showSecondButton: false,
          secondButtonText: "",
        });
      }
    } catch (error) {
      this.setState({
        isGeneratingInvoice: false,
        showPopup: true,
        popupType: "error",
        popupHeading: "Invoice Generation Failed",
        popupMessage:
          error?.message ||
          "An error occurred while generating the invoice. Please try again.",
        showSecondButton: false,
        secondButtonText: "",
      });
    }
  };

  handlePopupOk = () => {
    this.setState({
      showPopup: false,
      popupHeading: "",
      popupMessage: "",
      showSecondButton: false,
      secondButtonText: "",
    });
  };

  handleCloseBillGeneration = () => {
    if (this.state.pdfUrl && !this.state.pdfUrl.startsWith("data:")) {
      window.URL.revokeObjectURL(this.state.pdfUrl);
    }
    this.pdfBlob = null;
    this.setState({
      showBillGeneration: false,
      pdfUrl: null,
      invoiceFileName: "",
    });
  };

  handleCompleteKyc = () => {
    this.setState({
      showPopup: false,
      popupHeading: "",
      popupMessage: "",
      showSecondButton: false,
      secondButtonText: "",
    });
    window.location.href = "/cabKYC";
  };

  handleSubmitInvoice = async () => {
    this.setState({ isSubmittingInvoice: true });
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Invoice Submitted", {
      view_from: "Invoice page",
      mobile_number: this.state.userMobileNo,
      type: "CABOWNER",
    });
    try {
      const { invoiceNumber, invoiceDate, selectedInvoices } = this.state;
      const { userDetails } = this.state;

      const invoiceDateTimestamp = moment(invoiceDate, "DD/MM/YYYY").valueOf();

      const requestBody = {
        invoiceNumber: invoiceNumber,
        invoiceDate: invoiceDateTimestamp,
        cabOperatorId: userDetails._id,
        cabBookingGroupIds: selectedInvoices.map((invoice) => invoice.key),
      };

      const path = `/cabOperator/createInvoiceTrips`;
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: requestBody,
      };

      const response = await Fetch(path, options, true);

      if (response && response.statusCode === "error") {
        this.setState({
          isSubmittingInvoice: false,
          showPopup: true,
          popupType: "error",
          popupHeading: "Invoice Creation Failed",
          popupMessage:
            response.message || "Failed to create invoice. Please try again.",
          showSecondButton: false,
          secondButtonText: "",
        });
        return;
      }

      if (
        response &&
        response.success !== false &&
        response.statusCode !== "error"
      ) {
        this.setState({
          showBillGeneration: false,
          pdfUrl: null,
          isSubmittingInvoice: false,
          showPopup: true,
          popupType: "success",
          popupHeading: "Invoice Created Successfully",
          popupMessage:
            "Your invoice has been created and submitted successfully.",
          showSecondButton: false,
          secondButtonText: "",
          selectedRowKeys: [],
          selectedInvoices: [],
        });
        try {
          const refreshedInvoice = await this.refreshInvoiceData();
          this.setState({ invoiceTableData: refreshedInvoice.formatTableData });
        } catch (refreshError) {
          console.error("Error refreshing invoice data:", refreshError);
        }
      } else {
        this.setState({
          isSubmittingInvoice: false,
          showPopup: true,
          popupType: "error",
          popupHeading: "Invoice Creation Failed",
          popupMessage:
            response?.message || "Failed to create invoice. Please try again.",
          showSecondButton: false,
          secondButtonText: "",
        });
      }
    } catch (error) {
      this.setState({
        isSubmittingInvoice: false,
        showPopup: true,
        popupType: "error",
        popupHeading: "Invoice Creation Failed",
        popupMessage:
          error?.message ||
          "An error occurred while creating the invoice. Please try again.",
        showSecondButton: false,
        secondButtonText: "",
      });
    }
  };

  formatData = (response) => {
    const data = response.map((data) => {
      return {
        key: data.id,
        route: data.from + "-" + data.to,
        date: moment(data.startTime).format("hh:mm A DD MMM YY"),
        tripId: data.groupCode,
        assetType: data.seater,
        amount: data.supplyCost,
        status: data.status,
      };
    });
    return data;
  };

  directSearh = async (value) => {
    const { allData } = this.state;
    let filterData = allData.filter((data) => data.rc == value);
    this.setState({ invoiceTableData: filterData });
  };

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  toggleMobileFilter = () => {
    this.setState({ showMobileFilter: !this.state.showMobileFilter });
  };

  applyMobileFilter = async () => {
    const { filterFromDate, filterToDate } = this.state;

    if (!filterFromDate || !filterToDate) {
      message.warning("Please select both from and to dates");
      return;
    }

    this.setState({ tableLoader: true, showMobileFilter: false });

    try {
      const fromDateString = filterFromDate.format("DD/MM/YYYY");
      const toDateString = filterToDate.format("DD/MM/YYYY");

      const fromDateMs = moment(fromDateString, "DD/MM/YYYY").valueOf();
      const toDateMs = moment(toDateString, "DD/MM/YYYY")
        .endOf("day")
        .valueOf();

      const path = `/cabOperator/tripsForInvoice?fromDate=${fromDateMs}&toDate=${toDateMs}`;
      const options = {
        method: "get",
      };

      const trips = await Fetch(path, options);

      let stateObj = { tableLoader: false };

      if (Array.isArray(trips) && trips.length > 0) {
        stateObj.invoiceTableData = this.formatData(trips);

        const dates = [filterFromDate, filterToDate];
        const dateStrings = [fromDateString, toDateString];

        stateObj.currentDateRange = {
          fromDate: fromDateMs,
          toDate: toDateMs,
          dates,
          dateStrings,
        };
      } else {
        message.error("no Trip Found");
        stateObj.invoiceTableData = [];
      }

      this.setState(stateObj);
    } catch (error) {
      console.error("Error fetching trips:", error);
      message.error("Failed to fetch trips");
      this.setState({ tableLoader: false });
    }
  };

  refreshInvoiceData = async () => {
    const { currentDateRange } = this.state;

    if (currentDateRange) {
      const path = `/cabOperator/tripsForInvoice?fromDate=${currentDateRange.fromDate}&toDate=${currentDateRange.toDate}`;
      const options = {
        method: "get",
      };
      const trips = await Fetch(path, options);

      if (Array.isArray(trips) && trips.length > 0) {
        return { trips, formatTableData: this.formatData(trips) };
      } else {
        message.error("no Trip Found");
        return { invoiceTableData: [], trips: [], formatTableData: [] };
      }
    } else {
      return await this.fetchInvoice();
    }
  };

  onRangeChange = async (dates, dateStrings) => {
    let stateObj = {};
    if (dates) {
      const fromDate = moment(dateStrings[0], "DD/MM/YYYY").valueOf();
      const toDate = moment(dateStrings[1], "DD/MM/YYYY")
        .endOf("day")
        .valueOf();

      // Store the current date range
      stateObj.currentDateRange = { fromDate, toDate, dates, dateStrings };

      const path = `/cabOperator/tripsForInvoice?fromDate=${fromDate}&toDate=${toDate}`;
      const options = {
        method: "get",
      };
      const trips = await Fetch(path, options);

      if (Array.isArray(trips) && trips.length > 0) {
        stateObj.invoiceTableData = this.formatData(trips);
      } else {
        message.error("no Trip Found");
        stateObj.invoiceTableData = [];
        stateObj.formatTableData = [];
        stateObj.trips = [];
      }
    } else {
      const invoice = await this.fetchInvoice();
      stateObj.invoiceTableData = invoice.formatTableData;
      // Reset current date range when clearing the date picker
      stateObj.currentDateRange = null;
    }
    this.setState(stateObj);
  };

  render() {
    const {
      loading,
      selectedRowKeys = [],
      tableLoader,
      invoiceTableData,
      isMobile,
      createInvoiceModal,
      showBillGeneration,
      selectedInvoices = [],
      showSideMenu,
      step,
      isRcm,
      invoiceDate,
      showPopup,
      popupType,
      popupHeading,
      popupMessage,
      showSecondButton,
      secondButtonText,
      pdfUrl,
      invoiceFileName,
      isGeneratingInvoice,
      isSubmittingInvoice,
      invoiceNumberError,
      showMobileFilter,
      filterFromDate,
      filterToDate,
    } = this.state;

    let active = 9;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <>
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={active}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          <div class="container">
            {showBillGeneration ? (
              <div className={less.billGeneration}>
                <div className={less.header}>
                  <img
                    onClick={this.handleCloseBillGeneration}
                    src="https://d1flzashw70bti.cloudfront.net/original/images/operator/backarrow.svg"
                    alt="back arrow"
                  />
                  <span>Bill Generation</span>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/operator/backarrow.svg"
                    alt="back arrow"
                    className={less.backImg}
                  />
                </div>
                <div
                  className={less.pdfViewer}
                  style={{ height: "60vh", overflow: "hidden" }}
                >
                  {pdfUrl ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <object
                        data={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style={{
                          border: "none",
                          borderRadius: "0 0 8px 8px",
                          flex: 1,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            backgroundColor: "#f9f9f9",
                            padding: "20px",
                          }}
                        >
                          <svg
                            width="80"
                            height="80"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#7B2AFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ marginBottom: "20px" }}
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                          </svg>
                          {/* <p
                            style={{
                              marginBottom: "20px",
                              textAlign: "center",
                              color: "#666",
                            }}
                          >
                            Your invoice is ready!
                          </p> */}
                          <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View PDF
                          </a>
                        </div>
                      </object>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      <p>Loading PDF...</p>
                    </div>
                  )}
                </div>
                <div
                  className={less.footer}
                  style={{ display: "flex", gap: "20px", width: "100%" }}
                >
                  <button
                    onClick={this.handleCloseBillGeneration}
                    style={{
                      background: "#F6F6F6",
                      color: "black",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      flex: 1,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={this.handleSubmitInvoice}
                    disabled={isSubmittingInvoice}
                    style={{
                      background: "#7B2AFF",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      flex: 1,
                      cursor: "pointer",
                      opacity: isSubmittingInvoice ? 0.6 : 1,
                    }}
                  >
                    {isSubmittingInvoice ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className={less.header}>
                  <div>
                    <span>Create Invoice</span>
                    <span>Select trips to start creating an invoice</span>
                  </div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/operatorWallet/filter.svg"
                    alt="filter"
                    onClick={this.toggleMobileFilter}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div className={less.body}>
                  {invoiceTableData.length > 0 ? (
                    invoiceTableData.map((inv, index) => (
                      <div className={less.tableWrapper}>
                        <div className={less.invoiceSelector}>
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              let keys = [...selectedRowKeys];
                              let invoices = [...selectedInvoices];
                              if (e.target.checked) {
                                if (keys.length > 60) {
                                  message.error(
                                    "You can select maximum 60 trips for an invoice"
                                  );
                                  return;
                                }
                                keys.push(index);
                                invoices.push(inv);
                              } else {
                                let indexOfKey = keys.indexOf(index);
                                let indexOfInvoice = invoices.indexOf(inv);
                                if (indexOfKey > -1) {
                                  keys.splice(indexOfKey, 1);
                                }
                                if (indexOfInvoice > -1) {
                                  invoices.splice(indexOfInvoice, 1);
                                }
                              }
                              this.setState({
                                selectedRowKeys: keys,
                                selectedInvoices: invoices,
                              });
                            }}
                            checked={selectedRowKeys.includes(index)}
                          />
                        </div>
                        <div className={less.invoice}>
                          <div className={less.tripHeader}>
                            <span>{inv.route}</span>
                            <span>{inv.assetType}</span>
                          </div>
                          <div className={less.tripDetails}>
                            <span>{moment(inv.date).format("hh:mm A")}</span>
                            <div className={less.divider}></div>
                            <span>{moment(inv.date).format("DD MMM YY")}</span>
                          </div>
                          <span>Trip ID: {inv.tripId}</span>
                          <span>Amount: ₹{inv.amount}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={less.noData}>No Invoices Found</div>
                  )}
                </div>
                {selectedRowKeys.length > 0 ? (
                  <div className={less.footer}>
                    <div>
                      <div>
                        <span>Selected Trips:{selectedRowKeys.length}</span>
                      </div>
                      <div>
                        <span>
                          Total: ₹{this.calculateTotalAmount().toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <button
                      className="btnPrimary"
                      onClick={this.handleCreateInvoiceClick}
                    >
                      Create Invoice
                    </button>
                  </div>
                ) : null}
                <Modal
                  open={createInvoiceModal}
                  footer={null}
                  onCancel={() => {
                    this.setState({ createInvoiceModal: false });
                  }}
                >
                  <div className={less.createInvoiceModal}>
                    <span>Enter Invoice Details</span>
                    <span>Please enter invoice details to continue.</span>
                    <div>
                      <span>Invoice Number *</span>
                      <input
                        type="text"
                        placeholder={
                          isRcm ? "Auto-generated" : "Enter Invoice Number"
                        }
                        value={this.state.invoiceNumber || ""}
                        onChange={(e) =>
                          this.handleChange("invoiceNumber", e.target.value)
                        }
                        disabled={isRcm}
                        style={
                          isRcm
                            ? {
                                backgroundColor: "#f5f5f5",
                                cursor: "not-allowed",
                                color: "#666",
                              }
                            : {}
                        }
                      />
                      {isRcm && (
                        <span
                          style={{
                            color: "#666",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                          }}
                        >
                          Invoice number is auto-generated for RCM users
                        </span>
                      )}
                      {invoiceNumberError && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                          }}
                        >
                          {invoiceNumberError}
                        </span>
                      )}
                    </div>
                    <div>
                      <span>Invoice Date *</span>
                      <DatePicker
                        onChange={(date, dateString) =>
                          this.handleChange("invoiceDate", dateString)
                        }
                        format="DD/MM/YYYY"
                        style={{ width: "100%" }}
                        disabled={true}
                        value={
                          this.state.invoiceDate
                            ? moment(this.state.invoiceDate, "DD/MM/YYYY")
                            : null
                        }
                      />
                    </div>
                    <div className={less.btnWrapper}>
                      <button
                        onClick={() => {
                          this.setState({ createInvoiceModal: false });
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={this.handleContinueClick}
                        disabled={isGeneratingInvoice}
                        style={{ opacity: isGeneratingInvoice ? 0.6 : 1 }}
                      >
                        {isGeneratingInvoice ? "Generating..." : "Continue"}
                      </button>
                    </div>
                  </div>
                </Modal>
              </>
            )}

            {showMobileFilter && (
              <>
                <div
                  className={less.mobileFilterOverlay}
                  onClick={this.toggleMobileFilter}
                ></div>

                <div className={less.mobileFilterPopup}>
                  <div
                    className={less.mobileFilterHandle}
                    onClick={this.toggleMobileFilter}
                  ></div>

                  <div className={less.mobileFilterHeader}>
                    <div className={less.mobileFilterTitle}>Filter Trips</div>
                    <div
                      className={less.mobileFilterClose}
                      onClick={this.toggleMobileFilter}
                    >
                      ×
                    </div>
                  </div>

                  <div className={less.mobileFilterContent}>
                    <div className={less.mobileFilterField}>
                      <label className={less.mobileFilterLabel}>
                        From Date
                      </label>
                      <DatePicker
                        className={less.mobileFilterInput}
                        value={
                          !filterFromDate
                            ? null
                            : typeof filterFromDate === "string"
                            ? dayjs(filterFromDate)
                            : filterFromDate
                        }
                        onChange={(date) =>
                          this.setState({ filterFromDate: date })
                        }
                        placeholder="Select from date"
                        format="DD/MM/YYYY"
                        disabledDate={(current) =>
                          current && current.isAfter(dayjs(), "day")
                        }
                      />
                    </div>

                    <div className={less.mobileFilterField}>
                      <label className={less.mobileFilterLabel}>To Date</label>
                      <DatePicker
                        className={less.mobileFilterInput}
                        value={
                          !filterToDate
                            ? null
                            : typeof filterToDate === "string"
                            ? dayjs(filterToDate)
                            : filterToDate
                        }
                        onChange={(date) =>
                          this.setState({ filterToDate: date })
                        }
                        placeholder="Select to date"
                        format="DD/MM/YYYY"
                        disabledDate={(current) =>
                          current && current.isAfter(dayjs(), "day")
                        }
                      />
                    </div>

                    <div className={less.mobileFilterButtonContainer}>
                      <button
                        className={less.mobileFilterButton}
                        onClick={this.applyMobileFilter}
                        disabled={tableLoader}
                      >
                        {tableLoader ? "Searching..." : "Search"}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <GenericPopup
            isVisible={showPopup}
            type={popupType}
            heading={popupHeading}
            message={popupMessage}
            onOk={this.handlePopupOk}
            showSecondButton={showSecondButton}
            secondButtonText={secondButtonText}
            onSecondButton={this.handleCompleteKyc}
          />
        </>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={active} isMobile={false} />
          <div className="container">
            <div className={less.header}>
              <div>
                <span>Create Invoice</span>
                <span>Select trips to start creating an invoice</span>
              </div>
              <RangePicker
                onChange={this.onRangeChange}
                format="DD/MM/YYYY"
                value={
                  this.state.currentDateRange
                    ? this.state.currentDateRange.dates
                    : [
                        dayjs().startOf("week").add(1, "day"),
                        dayjs().endOf("day"),
                      ]
                }
                disabledDate={(current) =>
                  current && current.isAfter(dayjs(), "day")
                }
              />
            </div>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#7b2bff",
                },
              }}
            >
              <Table
                loading={tableLoader}
                columns={columns}
                bordered={true}
                rowSelection={{
                  columnWidth: "4%",
                  selectedRowKeys,
                  onChange: (keys, invoice) => {
                    if (keys.length > 60) {
                      message.error(
                        "You can select maximum 60 trips for an invoice"
                      );
                      return;
                    }
                    this.setState({
                      selectedInvoices: invoice,
                      selectedRowKeys: keys,
                    });
                  },
                }}
                dataSource={invoiceTableData}
                pagination={false}
                scroll={{ x: "100%", y: "60vh" }}
              />
            </ConfigProvider>

            <Modal
              open={createInvoiceModal}
              footer={null}
              onCancel={() => {
                this.setState({ createInvoiceModal: false });
              }}
            >
              <div className={less.createInvoiceModal}>
                <span>Enter Invoice Details</span>
                <span>Please enter invoice details to continue.</span>
                <div>
                  <span>Invoice Number *</span>
                  <input
                    type="text"
                    placeholder={
                      isRcm ? "Auto-generated" : "Enter Invoice Number"
                    }
                    value={this.state.invoiceNumber || ""}
                    onChange={(e) =>
                      this.handleChange("invoiceNumber", e.target.value)
                    }
                    disabled={isRcm}
                    style={
                      isRcm
                        ? {
                            backgroundColor: "#f5f5f5",
                            cursor: "not-allowed",
                            color: "#666",
                          }
                        : {}
                    }
                  />
                  {isRcm && (
                    <span
                      style={{
                        color: "#666",
                        fontSize: "12px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      Invoice number is auto-generated for RCM users
                    </span>
                  )}
                  {invoiceNumberError && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      {invoiceNumberError}
                    </span>
                  )}
                </div>
                <div>
                  <span>Invoice Date *</span>
                  <DatePicker
                    onChange={(date, dateString) =>
                      this.handleChange("invoiceDate", dateString)
                    }
                    format="DD/MM/YYYY"
                    style={{ width: "100%" }}
                    disabled={true}
                    value={
                      this.state.invoiceDate
                        ? moment(this.state.invoiceDate, "DD/MM/YYYY")
                        : null
                    }
                  />
                </div>
                <div className={less.btnWrapper}>
                  <button
                    onClick={() => {
                      this.setState({ createInvoiceModal: false });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={this.handleContinueClick}
                    disabled={isGeneratingInvoice}
                    style={{ opacity: isGeneratingInvoice ? 0.6 : 1 }}
                  >
                    {isGeneratingInvoice ? "Generating..." : "Continue"}
                  </button>
                </div>
              </div>
            </Modal>
            <Modal
              open={showBillGeneration}
              footer={null}
              onCancel={this.handleCloseBillGeneration}
              width="90%"
              style={{ maxWidth: "1200px" }}
              centered
              destroyOnClose
              maskClosable={false}
              bodyStyle={{
                padding: "20px",
                maxHeight: "80vh",
                overflow: "auto",
              }}
            >
              <div>
                <h3
                  style={{
                    marginBottom: "20px",
                    marginTop: "0",
                    textAlign: "left",
                  }}
                >
                  Bill Generation
                </h3>
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "20px",
                    height: "60vh",
                    overflow: "hidden",
                  }}
                >
                  {pdfUrl ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <object
                        data={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                        type="application/pdf"
                        width="100%"
                        height="100%"
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "0 0 8px 8px",
                          flex: 1,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                            backgroundColor: "#f9f9f9",
                            padding: "20px",
                            borderRadius: "0 0 8px 8px",
                          }}
                        >
                          <svg
                            width="80"
                            height="80"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#7B2AFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ marginBottom: "20px" }}
                          >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                          </svg>
                          <p
                            style={{
                              marginBottom: "20px",
                              textAlign: "center",
                              color: "#666",
                            }}
                          >
                            PDF preview not available in this browser.
                          </p>
                        </div>
                      </object>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "8px",
                      }}
                    >
                      <p>Loading PDF...</p>
                    </div>
                  )}
                </div>
                <div style={{ display: "flex", gap: "20px", width: "100%" }}>
                  <button
                    onClick={this.handleCloseBillGeneration}
                    style={{
                      background: "#F6F6F6",
                      color: "black",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      flex: 1,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={this.handleSubmitInvoice}
                    disabled={isSubmittingInvoice}
                    style={{
                      background: "#7B2AFF",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      flex: 1,
                      cursor: "pointer",
                      opacity: isSubmittingInvoice ? 0.6 : 1,
                    }}
                  >
                    {isSubmittingInvoice ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
          {selectedRowKeys.length > 0 ? (
            <div className={less.footer}>
              <div>
                <div>
                  <span>Selected Trips:{selectedRowKeys.length}</span>
                </div>
                <div>
                  <span>Total: ₹{this.calculateTotalAmount().toFixed(2)}</span>
                </div>
              </div>
              <button
                className="btnPrimary"
                onClick={this.handleCreateInvoiceClick}
              >
                Create Invoice
              </button>
            </div>
          ) : null}
          <GenericPopup
            isVisible={showPopup}
            type={popupType}
            heading={popupHeading}
            message={popupMessage}
            onOk={this.handlePopupOk}
            showSecondButton={showSecondButton}
            secondButtonText={secondButtonText}
            onSecondButton={this.handleCompleteKyc}
          />
        </div>
      );
    }
  }
}

export default buses;
